export const EmailIconSend = () => {
  return (
    <>
      <svg
        width='19'
        height='14'
        viewBox='0 0 19 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <title>Email IconSend</title>
        <path
          d='M7.28564 4.42853L10.8214 6.99997L14.3571 4.42853'
          stroke='#1F7CAB'
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M2.57129 8.28568H4.14267'
          stroke='#1F7CAB'
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M1 5.71429H4.14284'
          stroke='#1F7CAB'
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M4.14307 3.14284V2.71424C4.14307 1.7675 4.84668 1 5.71452 1H15.9288C16.7967 1 17.5003 1.7675 17.5003 2.71424V11.2858C17.5003 12.2325 16.7967 13 15.9288 13H5.71452C4.84668 13 4.14307 12.2325 4.14307 11.2858V10.8572'
          stroke='#1F7CAB'
          stroke-width='1.5'
          stroke-linecap='round'
        />
      </svg>
    </>
  );
};
